// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"styles_pageWrapper__wYH6P","center":"styles_center__p0Fgf","mdnCheckbox":"styles_mdnCheckbox__YaxCL","btnConsultar":"styles_btnConsultar__AyRIi"};